import type { ComponentProps } from 'react'
import GamingPlatform from '../components/GamingPlatform'

type Props = ComponentProps<typeof GamingPlatform>

export default function Step0_GamingPlatform(props: Props) {
  return <GamingPlatform {...props} />
}

